import { faUser } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  Box, ListItem, Text, UserProfileImage,
} from '@domain-group/suit-theme'

import { digObject, snakeToTitleCase } from '@domain-group/javascript-utils'

import useUser from '@hooks/useUser'

const SupportUserListItem = (props: { supportUserId: number }) => {
  const { supportUserId } = props

  const userPayload = useUser({ id: supportUserId })
  const { user, role } = userPayload

  const imageUrl = digObject(user, 'image.thumb_url', '')

  return (
    <ListItem
      boxProps={{ alignItems: 'center', borderBottom: '1px dashed', paddingX: 'large' }}
      disableHover
    >
      <UserProfileImage
        boxProps={{ display: 'inline-flex' }}
        circle
        imageUrl={imageUrl}
      >
        <FontAwesomeIcon icon={faUser} />
      </UserProfileImage>

      <Box flexDirection="column" padding="large">
        <Text color="bodyFontColor" fontSize="small">{user.title}</Text>

        {/*
         // @ts-expect-error TS2339 */}
        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">{snakeToTitleCase(role.title)}</Text>
      </Box>
    </ListItem>
  )
}

export default SupportUserListItem
